"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("../util");
var react_1 = __importStar(require("react"));
var lite_1 = __importDefault(require("algoliasearch/lite"));
var react_instantsearch_dom_1 = require("react-instantsearch-dom");
var IndexHit_1 = __importDefault(require("./IndexHit"));
var leaflet_geosearch_1 = require("leaflet-geosearch");
var lodash_1 = require("lodash");
var Hits = react_instantsearch_dom_1.connectHits(function (_a) {
    var hits = _a.hits;
    return (react_1.default.createElement(react_1.default.Fragment, null, hits.length > 0 && (react_1.default.createElement("div", { className: 'flex flex-col space-y-4 md:col-span-12' },
        react_1.default.createElement("h3", { className: 'font-bold text-lg' }, window.__('We vonden voor u een plaats  in volgende residentie:')),
        react_1.default.createElement("div", { className: "mt-6 grid grid-cols-auto-1fr" }, hits.map(function (hit) { return (react_1.default.createElement(IndexHit_1.default, { key: hit.objectID, hit: hit, showCity: false })); }))))));
});
var GeoSearch = function () {
    var input = util_1.$('[data-geosearch-input]');
    var _a = react_1.useState(null), search = _a[0], setSearch = _a[1];
    var searchClient = lite_1.default(window.Algolia.app_id, window.Algolia.search_key);
    var provider = new leaflet_geosearch_1.OpenStreetMapProvider();
    react_1.useEffect(function () {
        var listener = lodash_1.debounce(function (changeEvent) {
            var target = changeEvent.target;
            provider.search({ query: target.value + ', Belgium' }).then(function (results) {
                results = results.filter(function (result) { return ['boundary', 'place'].includes(result.raw.class); });
                if (!results.length) {
                    setSearch(null);
                    return;
                }
                setSearch({
                    lat: results[0].y,
                    lng: results[0].x,
                });
            });
        }, 200);
        input.addEventListener('input', listener);
        return function () {
            input.removeEventListener('input', listener);
        };
    }, [setSearch]);
    if (!search) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement(react_instantsearch_dom_1.InstantSearch, { searchClient: searchClient, indexName: window.Algolia.index_name },
        react_1.default.createElement(react_instantsearch_dom_1.Configure, { hitsPerPage: 1, facetFilters: [
                "locale:" + window.locale,
                'availability:Snel beschikbaar',
                'residence_categories:woonzorgcentrum'
            ], aroundLatLng: search.lat + "," + search.lng, aroundRadius: 20000 }),
        search.lat !== 0 && search.lng !== 0 && (react_1.default.createElement(Hits, null))));
};
exports.default = GeoSearch;
